// CSSの読み込み
import "../css/destyle.css";
import "../css/style.scss";

// 画像の読み込み
import icon from "../images/common/*.png";

// Particles JSの設定
window.onload = function () {
  particlesJS("main-visual-particle", {
    particles: {
      number: {
        value: 50,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#ffffff",
      },
      shape: {
        type: ["image"],
        image: {
          src: icon["star-white"],
          width: 300,
          height: 300,
        },
      },
      opacity: {
        value: 1,
        random: true,
        anim: {
          enable: false,
        },
      },
      size: {
        value: 40,
        random: true,
        anim: {
          enable: true,
          speed: 40,
          size_min: 5,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      move: {
        enable: true,
        speed: 20,
        direction: "none",
        random: true,
        straight: true,
        out_mode: "out",
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 600,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  });

  particlesJS("story-particle", {
    particles: {
      number: {
        value: 50,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#FCE877",
      },
      shape: {
        type: ["image", "star", "circle"],
        image: {
          src: icon["star-yellow"],
          height: 500,
          width: 500,
        },
      },
      opacity: {
        value: 0.7,
        random: false,
        anim: {
          enable: false,
          speed: 1,
          opacity_min: 0.1,
          sync: false,
        },
      },
      size: {
        value: 20,
        random: true,
        anim: {
          enable: false,
          speed: 20,
          size_min: 0.1,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      rotate: {
        value: 360,
        random: true,
        anim: {
          enable: true,
          speed: 5,
        },
      },
      move: {
        enable: true,
        speed: 1, //この数値を小さくするとゆっくりな動きになる
        direction: "bottom", //下に向かって落ちる
        random: true, //動きはランダム
        straight: false, //動きをとどめない
        out_mode: "out", //画面の外に出るように描写
        bounce: false, //跳ね返りなし
        attract: {
          enable: true,
          rotateX: 300,
          rotateY: 1200,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  });

  particlesJS("about-particle", {
    particles: {
      number: {
        value: 50,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#ffffff",
      },
      shape: {
        type: ["image"],
        image: {
          src: icon["star-white"],
          width: 200,
          height: 200,
        },
      },
      opacity: {
        value: 1,
        random: true,
        anim: {
          enable: false,
        },
      },
      size: {
        value: 35,
        random: true,
        anim: {
          enable: true,
          speed: 40,
          size_min: 5,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      move: {
        enable: true,
        speed: 20,
        direction: "none",
        random: true,
        straight: true,
        out_mode: "out",
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 600,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  });

  particlesJS("event-particle", {
    particles: {
      number: {
        value: 50,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#FCE877",
      },
      shape: {
        type: ["image", "star", "circle"],
        image: {
          src: icon["star-yellow"],
          height: 500,
          width: 500,
        },
      },
      opacity: {
        value: 0.7,
        random: false,
        anim: {
          enable: false,
          speed: 1,
          opacity_min: 0.1,
          sync: false,
        },
      },
      size: {
        value: 20,
        random: true,
        anim: {
          enable: false,
          speed: 20,
          size_min: 0.1,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      rotate: {
        value: 360,
        random: true,
        anim: {
          enable: true,
          speed: 5,
        },
      },
      move: {
        enable: true,
        speed: 1, //この数値を小さくするとゆっくりな動きになる
        direction: "bottom", //下に向かって落ちる
        random: true, //動きはランダム
        straight: false, //動きをとどめない
        out_mode: "out", //画面の外に出るように描写
        bounce: false, //跳ね返りなし
        attract: {
          enable: true,
          rotateX: 300,
          rotateY: 1200,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  });

  particlesJS("road-map-particle", {
    particles: {
      number: {
        value: 50,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#ffffff",
      },
      shape: {
        type: ["image"],
        image: {
          src: icon["star-white"],
          width: 200,
          height: 200,
        },
      },
      opacity: {
        value: 1,
        random: true,
        anim: {
          enable: false,
        },
      },
      size: {
        value: 35,
        random: true,
        anim: {
          enable: true,
          speed: 40,
          size_min: 5,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      move: {
        enable: true,
        speed: 20,
        direction: "none",
        random: true,
        straight: true,
        out_mode: "out",
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 600,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  });

  particlesJS("member-particle", {
    particles: {
      number: {
        value: 80,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#FCE877",
      },
      shape: {
        type: ["image", "star", "circle"],
        image: {
          src: icon["star-yellow"],
          height: 500,
          width: 500,
        },
      },
      opacity: {
        value: 0.7,
        random: false,
        anim: {
          enable: false,
          speed: 1,
          opacity_min: 0.1,
          sync: false,
        },
      },
      size: {
        value: 20,
        random: true,
        anim: {
          enable: false,
          speed: 20,
          size_min: 0.1,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      rotate: {
        value: 360,
        random: true,
        anim: {
          enable: true,
          speed: 5,
        },
      },
      move: {
        enable: true,
        speed: 1, //この数値を小さくするとゆっくりな動きになる
        direction: "bottom", //下に向かって落ちる
        random: true, //動きはランダム
        straight: false, //動きをとどめない
        out_mode: "out", //画面の外に出るように描写
        bounce: false, //跳ね返りなし
        attract: {
          enable: true,
          rotateX: 300,
          rotateY: 1200,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  });
};

// ハンバーガーメニューの処理
function scrollLock(event) {
  event.preventDefault();
}

let isScrollLocked = false;
document.querySelector(".js-hamburger-button").addEventListener("click", () => {
  document.querySelector(".js-hamburger-button").classList.toggle("is-open");
  document.querySelector(".js-hamburger-menu").classList.toggle("is-open");

  if (isScrollLocked) {
    document.removeEventListener("touchmove", scrollLock, {
      passive: false,
    });
    document.removeEventListener("mousewheel", scrollLock, {
      passive: false,
    });

    isScrollLocked = false;
  } else {
    document.addEventListener("touchmove", scrollLock, { passive: false });
    document.addEventListener("mousewheel", scrollLock, { passive: false });

    isScrollLocked = true;
  }
});

document.querySelectorAll(".js-hamburger-menu-link").forEach(function (button) {
  button.addEventListener("click", () => {
    document.querySelector(".js-hamburger-button").classList.toggle("is-open");
    document.querySelector(".js-hamburger-menu").classList.toggle("is-open");
    document.removeEventListener("touchmove", scrollLock, {
      passive: false,
    });
    document.removeEventListener("mousewheel", scrollLock, {
      passive: false,
    });

    isScrollLocked = false;
  });
});

// ヘッダーの処理
let position = 0,
  lastPosition = 0;

window.addEventListener("scroll", () => {
  position = window.scrollY;

  if (window.innerWidth < 1120) {
    if (position < lastPosition) {
      document.querySelector(".js-header").classList.remove("is-close");
    } else {
      if (position > 74) {
        document.querySelector(".js-header").classList.add("is-close");
      }
    }

    lastPosition = position;
  }
});
